import * as React from 'react';
const SvgAnalytics = (props) => (
  <svg viewBox="0 0 120 97" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#analytics_svg__a)"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M28.55 71.16v24.069H9.646V73.503M9.645 59.555V49.56h18.906v7.936M56.91 63.037V95.23H38.003v-28.7M38.004 52.642V22.85h18.905v26.483M85.262 61.63V95.23h-18.9v-28.67M66.361 52.642V37.89h18.9v11.215M113.62 43.24v51.989H94.715v-36.15M94.715 39.393V1.771h18.905v25.916" />
      <path d="M1.772 63.037a31.427 31.427 0 0 0 33.305-2.15 25.36 25.36 0 0 1 22.505-3.584l3.848 1.225a28.717 28.717 0 0 0 25.498-4.059l31.295-22.525" />
    </g>
    <defs>
      <clipPath id="analytics_svg__a">
        <path fill="#fff" d="M0 0h120v97H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAnalytics;
